const AmexOwnershipTypeIndicatorOptions = (list) => {
  const ownershipTypes = [
    { indicatorCode: "D", indicatorName: "Corporation Private" },
    { indicatorCode: "E", indicatorName: "Corporation Publicly Traded" },
    { indicatorCode: "M", indicatorName: "LLC Private" },
    { indicatorCode: "N", indicatorName: "LLC Publicly Traded" },
    { indicatorCode: "Q", indicatorName: "Partnership Private" },
    { indicatorCode: "R", indicatorName: "Partnership Publicly Traded" },
    { indicatorCode: "S", indicatorName: "Sole Proprietorship" },
    { indicatorCode: "F", indicatorName: "Non Profit" },
    { indicatorCode: "G", indicatorName: "Government" },
    {
      indicatorCode: "X",
      indicatorName: "American Express Reserved Indicator",
    },
  ];

  const resultList = ownershipTypes.map((item) => ({
    value: item.indicatorCode,
    title: `${item.indicatorCode} - ${item.indicatorName}`,
    key: item.indicatorCode,
  }));

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return resultList;
  }

  return resultList.length > 0 ? resultList : [];
};

export default AmexOwnershipTypeIndicatorOptions;
